import {toStr, isNum} from './number'
import {toNum, isStr} from './string'
// @ts-ignore
import _ from 'lodash'

export function numToStr(numbers: number[]): string[] | undefined {
  try {
    let strs = []
    for (const num of numbers) {
      strs.push(toStr(num) as string)
    }
    return strs;
  } catch (error) {
    throw error;
  }
}

export function strToNum(strings: string[]): number[] | undefined {
  try {
    let nums = []
    for (const str of strings) {
      nums.push(toNum(str) as number)
    }
    return nums;
  } catch (error) {
    throw error;
  }
}

export function onlyStr(arr: any[]): boolean {
  return arr.every(item => isStr(item));
}

export function onlyNum(arr: any[]): boolean {
  return arr.every(item => isNum(item));
}

export function allUniq (arr: any[]): boolean {
  let diff = arr.filter((item, index) => arr.indexOf(item) !== index)
  if (diff.length) {
    return false;
  } else {
    return true;
  }
}

export function acs(arr: string[] | number[]): string[] | number[] | undefined {
  try {
    if (onlyStr(arr) || onlyNum(arr)) {
      return arr.sort((a: string | number, b: string | number) => {
        return a > b ? 1 : -1;
      })
    } else {
      throw new Error(`Array is not onlyStr or onlyNum ${arr}`);
    }
  } catch (error) {
    throw error;
  }
}

export function desc(arr: string[] | number[]): string[] | number[] | undefined {
  try {
    if (onlyStr(arr) || onlyNum(arr)) {
      return arr.sort((a: string | number, b: string | number) => {
        return a > b ? 1 : -1;
      })
    } else {
      throw new Error(`Array is not onlyStr or onlyNum ${arr}`);
    }
  } catch (error) {
    throw error;
  }
}

export function coerce(data: any[], funcs: any[]): any[] {
  let result: any[] = _.cloneDeep(data)
  for (const func of funcs) {
    result = func(result)
  }
  return result;
}

const api: {[key: string]: any} = {
  numToStr,
  strToNum,
  acs,
  desc,
  coerce
}

export default api